/**
 * Created by simon zhao on 3/22/2022.
 * Description:
 * Data Model For Persisting Grid Layout Preference.
 * ------ maintenance history ------
 */

import { ColumnState } from 'ag-grid-community';

export const GROUP_DELIMINITER = ',';

export class GridLayoutModel {
    /**
     * an ID array of columns, by which the grid is grouped.
     * column ids are concatenated by comma.
     */
    GroupColumns: string;

    /**
     * the state of the columns.
     */
    Columns: ColumnState[];

    /**
     * the current state of all the advanced filters.
     */
    Filters: { [key: string]: any; };

    SortModel: { colId: string, sort: string }[];
}
